/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserAuthConfirmRequestDto
 */
export interface UserAuthConfirmRequestDto {
  /**
   *
   * @type {string}
   * @memberof UserAuthConfirmRequestDto
   */
  token: string;
}

export function UserAuthConfirmRequestDtoFromJSON(json: any): UserAuthConfirmRequestDto {
  return UserAuthConfirmRequestDtoFromJSONTyped(json, false);
}

export function UserAuthConfirmRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserAuthConfirmRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    token: json["token"],
  };
}

export function UserAuthConfirmRequestDtoToJSON(value?: UserAuthConfirmRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    token: value.token,
  };
}
